import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import VideoForm from '../VideoForm';

class Step4 extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
    applicants: PropTypes.number.isRequired,
  };

  renderContent = () => {
    const { season } = this.props;
    if (this.props.applicants > 1) {
      return (
        <div className="ui bottom attached tab segment accented active">
          <VideoForm form="team" season={season} />
        </div>
      );
    }
    return (
      <div className="ui bottom attached tab segment accented active">
        <VideoForm form="member1" season={season} />
      </div>
    );
  };

  renderTabSections() {
    if (this.props.applicants > 1) {
      return (
        <div
          style={{ borderColor: `#${this.props.hexColorCodeC}` }}
          className="ui top attached tabular menu accented"
        >
          <div className="item active">Team</div>
        </div>
      );
    }
    return '';
  }

  render() {

      return (
      <div>
        {this.renderTabSections()}
        {this.renderContent()}
      </div>
    );
  }
}

export default Step4;



// WEBPACK FOOTER //
// ./src/components/apply/Step4.js